import React from "react";
import { Button, Image } from "react-bootstrap";
import { useHistory } from "react-router";
import Switch from "react-switch";

export const ToggleButtonReuse = ({
  mainText,
  checkedBox,
  onChange,
  disabled,
  clickHandle,
  noButton,
}) => {
  return (
    <React.Fragment>
      <div className="casual-fastfood-hospitality-screen-toggle">
        <div className="d-flex justify-content-between w-100">
          <h4>{mainText}</h4>
          <Switch
            checked={checkedBox}
            onChange={onChange}
            offColor="#EEEEEE"
            onColor="#EEEEEE"
            offHandleColor="#212121"
            onHandleColor="#59F832"
            handleDiameter={16}
            uncheckedIcon={false}
            checkedIcon={false}
            height={10}
            width={27}
            boxShadow="-2px 0px 5px #0000003B"
            activeBoxShadow="-2px 0px 5px #0000003B"
            id="material-switch"
            disabled={disabled === true ? true : false}
          />
        </div>
        <div
          className="d-flex rightside-toggle-buttons-subscription-menu"
          // style={{ minWidth: "150px", marginLeft: "25px" }}
        >
          {checkedBox && !noButton && (
            <>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => {
                  clickHandle("view");
                }}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/eye.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => {
                  clickHandle("edit");
                }}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button>{" "}
            </>
          )}
        </div>
      </div>
    </React.Fragment>
  );
};

export const ToggleButtonReuseTwo = ({
  mainText,
  paragraphText,
  checkedBox,
  onChange,
  disabled,
  editButtons,
}) => {
  const history = useHistory();
  return (
    <React.Fragment>
      <div className="offers-events-screen-toggle">
        <div className="pt-1">
          <Switch
            checked={checkedBox}
            onChange={onChange}
            offColor="#EEEEEE"
            onColor="#EEEEEE"
            offHandleColor="#212121"
            onHandleColor="#59F832"
            handleDiameter={16}
            uncheckedIcon={false}
            checkedIcon={false}
            height={10}
            width={27}
            disabled={disabled === true ? true : false}
            boxShadow="-2px 0px 5px #0000003B"
            activeBoxShadow="-2px 0px 5px #0000003B"
            id="material-switch"
          />
        </div>
        <div className="ml-3">
          <div className="f16-700">{mainText}</div>
          <div className="f11-400 opacity5">{paragraphText}</div>
        </div>
        {editButtons && (
          <div
            className="d-flex rightside-toggle-buttons-subscription-menu"
            // style={{ minWidth: "150px", marginLeft: "25px" }}
          >
            <>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => onChange("View")}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/eye.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => onChange("Edit")}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button>
            </>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};

export const ToggleButtonWithYesNo = ({
  activeClass,
  checkedBox,
  onChange,
  disabled,
  className,
  editButtons,
}) => {
  return (
    <React.Fragment>
      <div className="offers-events-screen-yes-no-toggle">
        <h3
          className={
            activeClass === false
              ? "offers-events-yes-no-active"
              : "offers-events-yes-no-notactive"
          }
        >
          No
        </h3>
        <Switch
          checked={checkedBox}
          onChange={onChange}
          offColor="#EEEEEE"
          onColor="#EEEEEE"
          offHandleColor="#212121"
          onHandleColor="#59F832"
          handleDiameter={16}
          uncheckedIcon={false}
          checkedIcon={false}
          height={10}
          width={27}
          disabled={disabled === true ? true : false}
          boxShadow="-2px 0px 5px #0000003B"
          activeBoxShadow="-2px 0px 5px #0000003B"
          className={`ml-3 mr-3 ${className}`}
          id="material-switch"
        />
        <h3
          className={
            activeClass === true
              ? "offers-events-yes-no-active"
              : "offers-events-yes-no-notactive"
          }
        >
          Yes
        </h3>
        {editButtons && (
          <div className="d-flex ml-3">
            <>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => onChange("View")}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/eye.svg")}
                  alt="View"
                  title="View"
                  fluid
                />
              </Button>
              <Button
                variant="link"
                className="enIconBtn mr-3"
                onClick={() => onChange("Edit")}
              >
                <Image
                  src={require("../../../../assets/images/UserManagement/pencil.svg")}
                  alt="Edit"
                  title="Edit"
                  fluid
                />
              </Button>
            </>
          </div>
        )}
      </div>
    </React.Fragment>
  );
};
